<template>
  <div class="favorite-btn" @mouseover="isShowComment = true" @mouseleave="isShowComment = false">
    <div class="favorite-btn__inside">
      <div class="favorite-btn__comment" v-show="isShowComment">お気に入りに追加</div>
      <v-btn icon @click="clickBtn()" v-if="isFavorite"><v-icon >favorite</v-icon></v-btn>
      <v-btn icon @click="clickBtn()" class="--notActive" v-if="!isFavorite"><v-icon>favorite_border</v-icon></v-btn>
    </div>
  </div>
</template>
<script>
import FavoriteService from '@/components/services/FavoriteService.vue'

export default {
  name: 'FavoriteStarBtn',
  props: {
    productId: Number
  },
  data () {
    return {
      alreadyFavoriteTune: null,
      isShowComment: false
    }
  },
  mounted () {
    this.checkContainInFavoriteList(this.productId)
  },
  watch: {
    async productId (val) {
      this.checkContainInFavoriteList(val)
    },
    isFavorite (val) {
    }
  },
  computed: {
    isFavorite () {
      return this.$store.getters.getContainFlag
    }
  },
  methods: {
    addFavorite: function (productId) {
      let formData = new URLSearchParams()
      formData.append('product_id', productId)
      formData.append('transactionid', this.$store.state.transactionId)
      FavoriteService.addFavoriteTune(formData, (response) => {
        this.$store.dispatch('favoriteListModuleSetContainFlag', true)
      }, (error) => {
        console.log(error)
      })
    },
    async checkContainInFavoriteList (productId) {
      await this.$store.dispatch('isContainFavoriteList', productId)
      this.alreadyFavoriteTune = this.$store.getters.getContainFlag
    },
    async clickBtn () {
      await this.$store.dispatch('apiGetFavoriteList', this.$store.state.transactionId)
      let alreadyContain = await this.$store.dispatch('isContainFavoriteList', this.productId)
      if (!alreadyContain) {
        this.addFavorite(this.productId)
        this.alreadyFavoriteTune = true
      } else {
        this.removeTuneFromFavoriteList(this.productId)
        this.alreadyFavoriteTune = false
      }
      // 保持情報の更新
      this.$store.dispatch('apiGetFavoriteList', this.$store.state.transactionId)
    },
    removeTuneFromFavoriteList: function () {
      let formData = new URLSearchParams()
      formData.append('product_id', this.productId)
      formData.append('transactionid', this.$store.state.transactionId)
      FavoriteService.removeFavoriteTune(formData, (response) => {
        this.$store.dispatch('favoriteListModuleSetContainFlag', false)
      }, (error) => {
        this.$log.debug(error)
      })
      this.$log.debug('removeTuneFromFavoriteList END')
    }
  }
}
</script>
<style scoped>
  .favorite-btn {
    z-index: 10;
  }
  .favorite-btn__inside {
    position: relative;
  }
  .favorite-btn /deep/ .icon {
    color: #ff80ab !important;
  }
  .--notActive /deep/ .icon{
    color: #555555 !important;
  }
  .favorite-btn__comment {
    width: 150px;
    position: absolute;
    top: -35px;
    right: 0;
    padding: 0.5rem;
    border-radius: 5px;
    background: rgba(51, 204, 153, 0.9);
    color: #fff;
    font-weight: bold;
    text-align: center;
  }
  .favorite-btn:hover + .favorite-btn__comment {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/FavoriteStarBtn.vue